/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {MdCommonModule} from '@angular/material/core';
import {MdIcon} from './icon';
import {ICON_REGISTRY_PROVIDER} from './icon-registry';
export class MdIconModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [MdCommonModule],
  exports: [MdIcon, MdCommonModule],
  declarations: [MdIcon],
  providers: [ICON_REGISTRY_PROVIDER],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdIconModule_tsickle_Closure_declarations() {
/** @type {?} */
MdIconModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdIconModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
